import { render, staticRenderFns } from "./_helpVer.vue?vue&type=template&id=af227a1a&"
import script from "./_helpVer.vue?vue&type=script&lang=js&"
export * from "./_helpVer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports